import urljoin from 'url-join';
/** @internal */
export class AuthProxyUrlBuilder {
    static isAuthProxy(authServiceOptions) {
        return Boolean(authServiceOptions.isAuthProxy);
    }
    static sanitizeRedirectUrlForLocalDevelopment(redirectUrl) {
        if (redirectUrl.startsWith('http://localhost:3000')) {
            return '';
        }
        return redirectUrl;
    }
    // please note: registeredFags not supported in oneaudi implementation
    static getLoginUrl(authServiceOptions, registeredFags, locale, prompt, redirectUrl, loginOptions) {
        if (prompt) {
            // `prompt` parameter currently not supported by mod_auth_openidc (the token proxy) to
            // force the user to see the login-page again. If you have a valid token-proxy session, the token proxy
            // will always send you back directly to your target page without triggering an auth flow. This
            // local logout of apache session is discussed here:
            // https://groups.google.com/forum/#!searchin/mod_auth_openidc/local$20session%7Csort:date/mod_auth_openidc/YcwYU-DPyAo/TlRLWUDCAwAJ
            // but there is no progress on this topic. Because we currently don't know any use-case for this for
            // oneaudi we will not respect the prompt parameter here and write a console warn message.
            // eslint-disable-next-line no-console
            console.warn('prompt currently not supported');
        }
        const idsso = loginOptions && loginOptions.idsso;
        let loginUrl = [
            authServiceOptions.authProxyUrl,
            idsso ? '/login' : '/login/idk',
            `?target=${encodeURIComponent(redirectUrl || authServiceOptions.defaultLoginRedirectUrl)}`,
        ];
        if (!idsso && AuthProxyUrlBuilder.isAuthProxy(authServiceOptions)) {
            const redirectAfterLogin = AuthProxyUrlBuilder.sanitizeRedirectUrlForLocalDevelopment(redirectUrl || authServiceOptions.defaultLoginRedirectUrl);
            const fags = registeredFags.join(',');
            loginUrl = [
                authServiceOptions.authProxyUrl,
                '/login',
                `?fag=${encodeURIComponent(fags)}&redirectUrl=${encodeURIComponent(redirectAfterLogin)}`,
            ];
        }
        if (!idsso) {
            loginUrl.push(`&ui_locales=${locale}`);
        }
        if (this.isAuthProxy(authServiceOptions)) {
            const fagScopesQuery = [];
            // eslint-disable-next-line no-restricted-syntax
            for (const fag of registeredFags) {
                const fagScopes = authServiceOptions.fagScopeMappings.get(fag);
                if (fagScopes && fagScopes.length > 0) {
                    fagScopesQuery.push(`scope-${fag}=${encodeURIComponent(fagScopes.join(','))}`);
                }
            }
            if (fagScopesQuery.length > 0) {
                loginUrl.push(`&${fagScopesQuery.join('&')}`);
            }
        }
        else {
            const scopes = [];
            // eslint-disable-next-line no-restricted-syntax
            for (const fag of registeredFags) {
                const fagScopes = authServiceOptions.fagScopeMappings.get(fag);
                if (fagScopes) {
                    scopes.push(...fagScopes);
                }
            }
            if (scopes.length > 0) {
                loginUrl.push(`&scopes=${encodeURIComponent(scopes.join(' '))}`);
            }
        }
        return urljoin(loginUrl);
    }
    static getInfoHookUrl(authServiceOptions) {
        if (AuthProxyUrlBuilder.isAuthProxy(authServiceOptions)) {
            return urljoin(authServiceOptions.authProxyUrl, '/myaudi/tokens');
        }
        return urljoin(authServiceOptions.authProxyUrl, '/info');
    }
    static getLogoutUrl(authServiceOptions, defaultOrigin, csrfToken, redirectUrl) {
        // TODO-MYA: respect csrf token
        const completeRedirectUrl = redirectUrl
            ? new URL(redirectUrl, defaultOrigin).toString()
            : undefined;
        let logoutUrl = [authServiceOptions.authProxyUrl, '/logout'];
        if (completeRedirectUrl) {
            logoutUrl.push(`?redirect=${encodeURIComponent(completeRedirectUrl)}`);
        }
        if (AuthProxyUrlBuilder.isAuthProxy(authServiceOptions)) {
            const redirectAfterLogout = AuthProxyUrlBuilder.sanitizeRedirectUrlForLocalDevelopment(completeRedirectUrl || authServiceOptions.defaultLoginRedirectUrl);
            logoutUrl = [
                authServiceOptions.authProxyUrl,
                '/logout',
                `?fag=myaudi&redirectUrl=${encodeURIComponent(redirectAfterLogout)}&_csrf=${csrfToken}`,
            ];
        }
        return urljoin(logoutUrl);
    }
    static getProxyUrl(authServiceOptions, resourceHostId, path) {
        const proxyUrlParts = [authServiceOptions.authProxyUrl];
        if (this.isAuthProxy(authServiceOptions)) {
            proxyUrlParts.push('myaudi/proxy');
        }
        if (!this.isAuthProxy(authServiceOptions) && resourceHostId) {
            proxyUrlParts.push(resourceHostId);
        }
        if (path) {
            proxyUrlParts.push(path);
        }
        if (this.isAuthProxy(authServiceOptions) && resourceHostId) {
            proxyUrlParts.push(`?resourceHost=${resourceHostId}`);
        }
        return urljoin(proxyUrlParts);
    }
    static getFormUrl(authServiceOptions, resourceHostId, path) {
        const proxyUrlParts = [authServiceOptions.authProxyUrl];
        if (this.isAuthProxy(authServiceOptions) &&
            authServiceOptions.authProxyFormMyaudiResourceHostId) {
            proxyUrlParts.push(authServiceOptions.authProxyFormMyaudiResourceHostId);
            if (path) {
                proxyUrlParts.push(path);
            }
            return urljoin(proxyUrlParts);
        }
        return AuthProxyUrlBuilder.getProxyUrl(authServiceOptions, resourceHostId, path);
    }
}
//# sourceMappingURL=AuthProxyUrlBuilder.js.map